import { defineStore } from 'pinia'
import useCustomFetch from '~/composables/useCustomFetch'
export const usePersonalpromotionStore = defineStore(
    'personalpromotionStore',
    () => {
        const fetcher = useCustomFetch()

        // GET /api-promotion/v1/verification/status
        const personalpromotionStatus = ref({})
        const getPersonalpromotionStatus = async () => {
            try {
                const { data } = await fetcher.getPromotion(
                    '/verification/status'
                )

                if (data.value?.status === 'OK') {
                    personalpromotionStatus.value = data.value.data
                }
            } catch (error) {
                console.log('personalpromotionStore', error)
            }
        }

        // POST /api-promotion/v1/verification/gift

        const getPersonalpromotionGift = async () => {
            try {
                const { data, pending, error } =
                    await fetcher.postPromotion('/verification/gift')
                return { data: data, pending, error }
            } catch (error) {
                console.log('personalpromotionStore', error)
            }
        }

        const userPromotionCashback = ref({})
        const isLoadingUserCashback = ref(true)
        const getUserPromotionCashback = async (week) => {
            try {
                const { data } = await fetcher.getPromotion(
                    `/cashback?from_date=${week.start}&to_date=${week.end}`
                )
                if (data.value?.status === 'OK') {
                    userPromotionCashback.value = data.value.data
                }
            } catch (error) {
                console.log('personalpromotionStore', error)
            } finally {
                isLoadingUserCashback.value = false
            }
        }

        const userPromotionDouble = ref({})
        const isLoadingPromotionDouble = ref(true)
        const getUserPromotionDouble = async () => {
            try {
                const { data } = await fetcher.get(`/account/info`)
                if (data.value?.status === 'OK') {
                    userPromotionDouble.value = data.value.data
                }
            } catch (error) {
                console.log('userPromotionDouble', error)
            } finally {
                isLoadingPromotionDouble.value = false
            }
        }

        return {
            personalpromotionStatus,
            getPersonalpromotionStatus,
            getPersonalpromotionGift,
            getUserPromotionCashback,
            userPromotionCashback,
            isLoadingUserCashback,
            userPromotionDouble,
            isLoadingPromotionDouble,
            getUserPromotionDouble,
        }
    }
)
